import React from 'react';

class FastPlugCurrentDateInput extends React.Component {
    render() {
        return (
            <div className="list-group-item text-light bg-primary border-0">
                <div className='form-floating'>
                    <input className="form-control" type="date" id="head-isFuture" 
                        value={this.props.value}
                        onChange={this.props.onChange} />
                    <label htmlFor="head-isFuture">
                        {this.props.label}
                    </label>
                </div>
            </div>
        )
    }
}

export default FastPlugCurrentDateInput;